// Mock request — reemplaza la clase request para demo sin backend
import { mockCities, mockCategories, mockHomeItems } from './mockData.js';

class request {
    apiUrl = "";
    defToken = "mock-token";

    constructor(api) {
        this.apiUrl = api;
    }

    _respond(data, delay = 300) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ code: "200", data: data });
            }, delay);
        });
    }

    // --- Ciudades / Sucursales ---
    getCities() {
        return this._respond(mockCities, 500);
    }

    getStoreStatus() {
        return this._respond({ status: "open", schedule: "11:00 - 22:00" });
    }

    // --- Catálogo ---
    getCategories() {
        return this._respond(mockCategories);
    }

    getCategory(categoryId) {
        const catData = mockHomeItems.find(c => c.idCat == categoryId);
        return this._respond(catData ? catData.item : []);
    }

    getHomeItems() {
        return this._respond(mockHomeItems);
    }

    getFavorites() {
        const favs = [];
        mockHomeItems.forEach(cat => {
            cat.item.forEach(p => favs.push(p));
        });
        return this._respond(favs.slice(0, 6));
    }

    getProduct(data) {
        for (let cat of mockHomeItems) {
            const product = cat.item.find(p => p.idItem == data.id);
            if (product) {
                return this._respond(product);
            }
        }
        return this._respond(null);
    }

    getProductOptions(data) {
        for (let cat of mockHomeItems) {
            const product = cat.item.find(p => p.idItem == data.id);
            if (product) {
                return this._respond({
                    ...product,
                    options: [],
                    modifiers: []
                });
            }
        }
        return this._respond(null);
    }

    // --- Banners ---
    getTransitions() {
        return this._respond([
            { type: 'image', file: require('@/assets/images/banners/mbchicken-canadas-favorite.jpg'), bgColor: '#000', duration: 5 },
            { type: 'image', file: require('@/assets/images/banners/mbchicken-lunes-big-mary.jpg'), bgColor: '#000', duration: 5 },
            { type: 'image', file: require('@/assets/images/banners/mbchicken-signature-chicken.jpg'), bgColor: '#f5f0eb', duration: 5 },
            { type: 'image', file: require('@/assets/images/banners/mbchicken-big-mary-sandwich.jpg'), bgColor: '#f5f0eb', duration: 5 },
        ]);
    }

    // --- Auth (mock) ---
    getLogin() {
        return this._respond({ message: "mock" }, 100);
    }

    checkCodeValidation() {
        return this._respond({ token: "mock-token" }, 100);
    }

    registerUser() {
        return this._respond({ success: true }, 100);
    }

    updateUser() {
        return this._respond({ success: true }, 100);
    }

    getUserData() {
        return this._respond({
            name: "Demo",
            lastName: "MB Chicken",
            email: "demo@mbchicken.mx",
            phone: ""
        });
    }

    // --- Carrito ---
    saveCar() {
        return this._respond({ success: true });
    }

    getCar() {
        return this._respond(null, 100);
    }

    // --- Direcciones ---
    getColoniesMatch() {
        return this._respond([]);
    }

    saveUserAddress() {
        return this._respond({ success: true });
    }

    // --- Pedidos ---
    placeOrder() {
        return this._respond({ orderId: "MOCK-001" });
    }

    getLastOrders() {
        return this._respond([]);
    }
}

export { request };
